import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ SET LOCAL DECLARATION VALUE
 * Upserts one attribute's value for a company/period — always supersedes
 * any prior active value for the same (company, attribute, year).
 * Targets: DeclrLocalDeclarationController.set (Corp.usp_Z_12_Declr_LocalDeclaration_Set)
 */
export const setLocalDeclaration = async (corporateEntityId, attributeDefinitionId, reportingYear, enteredValue, enteredUnitCode, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-local-declaration/set",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({
                CorporateEntityId: corporateEntityId,
                AttributeDefinitionId: attributeDefinitionId,
                ReportingYear: reportingYear,
                EnteredValue: enteredValue === "" || enteredValue === undefined ? null : String(enteredValue),
                EnteredUnitCode: enteredUnitCode || null,
            })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not save declaration value.");
        return res.data;
    } catch (err) {
        console.error("Declr Local Declaration Set Error:", err);
        throw err;
    }
};

/**
 * 🛰️ LIST LOCAL DECLARATION VALUES
 * All values a company has entered for a reporting year, joined to the
 * attribute definition (label/type/unit family) they belong to.
 * Targets: DeclrLocalDeclarationController.list (Corp.usp_Z_12_Declr_LocalDeclaration_List)
 */
export const fetchLocalDeclarations = async (corporateEntityId, reportingYear, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-local-declaration/list",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ CorporateEntityId: corporateEntityId, ReportingYear: reportingYear })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Declr Local Declaration List Failed:", err);
        return [];
    }
};
